export default __webpack_public_path__ + "420daedecc39a005cc620de3008a8e29.png";